// import { handleActions } from 'redux-actions';
import * as SignIn from '../../constants/User/SignIn';

const initialState = {
  signInLoading: false,
  signInLoaded: false,
  signInResult: false,
  twitterRedirect: false,
  googleRedirect: false,
  facebookRedirect: false
}


export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SignIn.USER_FACEBOOK_SIGN_IN:
      // console.log('sign_in', state, action)
      return state;
    case SignIn.USER_FACEBOOK_SIGN_IN_REQUEST:
      // console.log('sign_in_request', state, action)
      return Object.assign({}, state, {
        signInLoading: true,
        signInLoaded: false,
        signInResult: false
      });
    case SignIn.USER_FACEBOOK_SIGN_IN_RESULT:
      // console.log('sign_in_result', state, action)
      return Object.assign({}, state, {
        signInLoading: false,
        signInLoaded: true,
        signInResult: (action.access_token.length > 0),
        facebookRedirect: true
      });
    case SignIn.USER_TWITTER_SIGN_IN:
      return state;
    case SignIn.USER_TWITTER_SIGN_IN_REQUEST:
      return Object.assign({}, state, {
        signInLoading: true,
        signInLoaded: false,
        signInResult: false
      });
    case SignIn.USER_TWITTER_SIGN_IN_RESULT:
      return Object.assign({}, state, {
        signInLoading: false,
        signInLoaded: true,
        signInResult: (action.access_token.length > 0),
        twitterRedirect: true
      });
    
    case SignIn.USER_GOOGLE_SIGN_IN:
      return state;
    
    case SignIn.USER_GOOGLE_SIGN_IN_REQUEST:
      return Object.assign({}, state, {
        signInLoading: true,
        signInLoaded: false,
        signInResult: false
      });
    
    case SignIn.USER_GOOGLE_SIGN_IN_RESULT:
      return Object.assign({}, state, {
        signInLoading: false,
        signInLoaded: true,
        signInResult: (action.access_token.length > 0),
        googleRedirect: true
      });
    
    case SignIn.USER_GOOGLE_SIGN_IN_TO_SERVER:
      return Object.assign({}, state, {
        google: true
      })
    
    // case SignIn.USER_AFTER_TWITTER_REDIRECT:
    //   return Object.assign({}, state, {
    //     twitterRedirect: false
    //   });
    // case SignIn.USER_TWITTER_SIGN_IN_ERROR:
    //   console.log('[reducer] twitter sign in error')
    //   return Object.assign({}, state, {
    //     signInLoading: false,
    //     signInLoaded: false,
    //     signInResult: false,
    //     signInError: true,
    //     signInErrorMsg: action.error
    //   });
    // case SignIn.ERROR_MSG_CLOSE:
    //   return Object.assign({}, state, {
    //     signInError: false,
    //     signInErrorMsg: ''
    //   })
    // case SignIn.SUCCESS_MSG_CLOSE:
    //   return Object.assign({}, state, {
    //     signInSuccessMsg: ''
    //   });
    default:
      return state;  
  }
}


// WEBPACK FOOTER //
// ./src/reducers/User/SignIn.js